<ng-template [ngIf]="!(hideCookiesConsent$ | async)">
  <div class="popup">
    This site uses cookies from Google to deliver its services and to analyze traffic.

    <div class="buttons">
      <a mat-button
        tabindex="0"
        rel="noopener"
        target="_blank"
        aria-disabled="false"
        [href]="moreDetailsLink"
        class="mat-focus-indicator mat-button more-details-btn"
      >MORE DETAILS</a>
      <button
        mat-button
        tabindex="0"
        color="primary"
        (click)="cookiesService.acceptCookiesConsent()"
        class="mat-focus-indicator mat-button mat-primary ok-btn">
        OK, GOT IT
      </button>
    </div>
  </div>
</ng-template>
